// SITE MODE SWITCH
// true  = only the Customizer (/) and Design Submissions (/submissions) are live
// false = full store website is live (homepage, products, cart, checkout)
export const CUSTOMIZER_ONLY = false;
